import { useGate, useStore, useStoreMap } from 'effector-react'
import { LoadingBlock } from './LoadingBlock'
import { Gate, $cmsBlock, getCmsBlockFx } from './model'
import { Wrapper } from './styled'

export function Content() {
  useGate(Gate)

  const cmsBlock = useStoreMap($cmsBlock, (cms) => cms?.getAttributes())
  const isCmsBlockPending = useStore(getCmsBlockFx.pending)

  if (isCmsBlockPending) return <LoadingBlock />

  return (
    <Wrapper
      dangerouslySetInnerHTML={{
        __html: cmsBlock?.content || 'Контент не найден',
      }}
    />
  )
}
